import {NestedSheet} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/NestedSheet';
import {AnySlot} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SheetTypes';
import {SlotFormula} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/slot/SlotTypes';
import {SlotLocation} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SlotLocation';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';
import {computed} from 'mobx';

export class NestedFrameSlot extends AnySlot
{
    private constructor()
    {
        super();
    }

    public static create(sheet:NestedSheet,
                         formula:SlotFormula,
                         location:SlotLocation):NestedFrameSlot
    {
        const slot:NestedFrameSlot = new NestedFrameSlot();

        slot.id = IdUtil.newGUID();
        slot.sheet = sheet;
        // slot.formula = formula;
        slot.location = location;

        slot.value = formula as IValue;

        return slot;
    }

    @computed
    public get isSimpleValue():boolean
    {
        return true;
    }

    @computed
    public get isLazy():boolean
    {
        return false;
    }

    @computed
    public get isLive():boolean
    {
        return false;
    }

    @computed
    public get isAccumulative():boolean
    {
        return false;
    }
}
